export class CommonDataBuilder {
  constructor(data) {
    this.emailRegexp = data.emailRegexp
    this.mainCity = this.buildCityDefault(data.cityDefault)

    this.minimumAge = data.minimumAge
    this.adultAge = data.adultAge

    this.languageDefaultCode = data.languageDefaultCode
    this.baseUrl = data.baseUrl
    this.languages = data.languages

    this.toggle = {
      addressBlockEnabled: !!data.extendedAddressBlockEnabled,
    }
  }

  buildCityDefault(data) {
    return { value: data.fiasId, text: data.title }
  }
}
